// src/utils/dateUtils.ts
export function normalizeTimestamp(
  ts: string | { toDate?(): Date } | { seconds?: number } | undefined | null,
): string {
  if (!ts) return "";

  // ISO string format
  if (typeof ts === "string") {
    return ts;
  }

  // Firestore Timestamp with toDate() method
  if (
    typeof ts === "object" &&
    "toDate" in ts &&
    typeof ts.toDate === "function"
  ) {
    return ts.toDate().toISOString();
  }

  // Firestore Timestamp with seconds property
  if (typeof ts === "object" && "seconds" in ts) {
    return new Date((ts as any).seconds * 1000).toISOString();
  }

  return "";
}

export function formatFinnishDate(
  ts: string | { toDate?(): Date } | { seconds?: number } | undefined | null,
): string {
  const isoString = normalizeTimestamp(ts);
  if (!isoString) return "";

  return new Date(isoString).toLocaleDateString("fi-FI", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function formatFinnishDateShort(
  ts: string | { toDate?(): Date } | { seconds?: number } | undefined | null,
): string {
  const isoString = normalizeTimestamp(ts);
  if (!isoString) return "";

  return new Date(isoString).toLocaleDateString("fi-FI", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
